import { DirectoryEntry } from '@ionic-native/file';
import { Action } from '@ngrx/store';
import { MediaPickerFiltersModel } from './media-picker-filters.model';
import { MediaPickerItemModel } from './media-picker-item.model';
import { GridInfo, TouchEventType } from './media-picker-modal.types';

export const ADD_FILE_MODELS = '[Media Picker] Add File Models';
export const CANCEL = '[Media Picker] Cancel';
export const CANCEL_SELECTION = '[Media Picker] Exit Select Mode';
export const INITIALISE = '[Media Picker] Initialise';
export const INITIALISE_SUCCESS = '[Media Picker] Initialise Success';
export const LIST_DIRS = '[Media Picker] List Dirs';
export const LOAD_MORE = '[Media Picker] Load More';
export const HAMMER = '[Media Picker] Hammer';
export const MAKE_THUMBNAIL = '[Media Picker] Make Thumbnail';
export const MAKE_THUMBNAIL_SUCCESS = '[Media Picker] Make Thumbnail Success';
export const PRESS = '[Media Picker] Press';
export const SET_CURRENT_DIR = '[Media Picker] Set Current Dir';
export const SET_FILTERS = '[Media Picker] Set Filters';
export const SUBMIT = '[Media Picker] Submit';
export const TAP = '[Media Picker] Tap';
export const TAP_DOUBLE = '[Media Picker] Tap Double';

export class AddFileModelsAction implements Action {
    readonly type = ADD_FILE_MODELS;

    constructor(public payload: {models: Array<MediaPickerItemModel>}) {
    }
}

export class CancelAction implements Action {
    readonly type = CANCEL;
}

export class CancelSelectionAction implements Action {
    readonly type = CANCEL_SELECTION;
}

export class InitialiseAction implements Action {
    readonly type = INITIALISE;

    constructor(public payload: {root: string, gridInfo: GridInfo}) {
    }
}

export class InitialiseSuccessAction implements Action {
    readonly type = INITIALISE_SUCCESS;

    constructor(public payload: {root: string, dirEntries: Array<DirectoryEntry>}) {
    }
}

export class ListDirsAction implements Action {
    readonly type = LIST_DIRS;

    constructor(public payload: {root: string, dirNames: Array<string>}) {
    }
}

export class LoadMore implements Action {
    readonly type = LOAD_MORE;
}

export class HammerAction implements Action {
    readonly type = HAMMER;

    constructor(public payload: {id: string, eventType: TouchEventType}) {
    }
}

export class MakeThumbnailAction implements Action {
    readonly type = MAKE_THUMBNAIL;

    constructor(public payload: {model: MediaPickerItemModel}) {
    }
}

export class MakeThumbnailSuccessAction implements Action {
    readonly type = MAKE_THUMBNAIL_SUCCESS;

    constructor(public payload: {
        model: MediaPickerItemModel
    }) {
    }
}

export class PressAction implements Action {
    readonly type = PRESS;

    constructor(public payload: {id: string}) {
    }
}

export class SetCurrentDir implements Action {
    readonly type = SET_CURRENT_DIR;

    constructor(public payload: {dirName: string}) {
    }
}

export class SetFiltersAction implements Action {
    readonly type = SET_FILTERS;

    constructor(public payload: {filters: MediaPickerFiltersModel}) {
    }
}

export class SubmitAction implements Action {
    readonly type = SUBMIT;

    constructor(public payload: {items: Array<MediaPickerItemModel>, accountId: string, jobId: string, group: string}) {
    }
}

export class TapAction implements Action {
    readonly type = TAP;
    constructor(public payload: {id: string}) {
    }
}

export class TapDoubleAction implements Action {
    readonly type = TAP_DOUBLE;
    constructor(public payload: {id: string}) {
    }
}

export declare type Actions =
    | AddFileModelsAction
    | CancelAction
    | CancelSelectionAction
    | InitialiseAction
    | InitialiseSuccessAction
    | ListDirsAction
    | LoadMore
    | SubmitAction
    | HammerAction
    | MakeThumbnailAction
    | MakeThumbnailSuccessAction
    | PressAction
    | SetCurrentDir
    | SetFiltersAction
    | TapAction
    | TapDoubleAction
    ;



// WEBPACK FOOTER //
// ./src/app/modals-popovers/media-picker-modal/media-picker-modal.actions.ts